import { Form, Input, Select, Card, Collapse, Row, Col } from "antd";
import { stateOptions } from "@/config";
import PropTypes from "prop-types";

const { Option } = Select;

const ReimbursementAddress = (props) => {
  const { meData } = props;
  ReimbursementAddress.propTypes = {
    meData: PropTypes.object.isRequired,
  };

  return (
    <Collapse
      className="mt-6"
      items={[
        {
          key: "1",
          label:
            "Expand this section if you would like to specify an alternative reimbursement address for this assistance request.",
          children: (
            <Row gutter={20}>
              <Col span={24}>
                <Form.Item>
                <span>
                  The fields below are required only if you would like to
                  re-direct copay assistance reimbursement to a different
                  address than that listed above. If the address fields below
                  are left blank, reimbursement will be sent to the{" "}
                  {meData.business_name} address listed above.
                </span>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  name="dispensing_pharmacy_business_name"
                  label="Reimbursement business name"
                >
                  <Input placeholder="Name of the business the reimbursement must be directed to and address below is for" />
                </Form.Item>
              </Col>

              <Col span={12}>

                <Form.Item
                  name="dispensing_pharmacy_addr"
                  label="Reimbursement address"
                >
                  <Input placeholder="Street address where financial reimbursement would be sent for this assistance request" />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="dispensing_pharmacy_addr_line2"
                  label="Reimbursement address line 2"
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={8}>
              <Form.Item
                name="dispensing_pharmacy_addr_city"
                label="Financial reimbursement city"
              >
                <Input />
              </Form.Item>
              </Col>

              <Col span={8}>
              <Form.Item
                name="dispensing_pharmacy_addr_state"
                label="Financial reimbursement state"
              >
                <Select placeholder="Please select state">
                  {stateOptions.map((option) => (
                    <Option value={option.value} key={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="dispensing_pharmacy_addr_zip"
                  label="Financial reimbursement ZIP code"
                >
                  <Input.OTP length={5} />
                </Form.Item>
              </Col>

              <Col span={16}>
                <Form.Item
                  name="dispensing_pharmacy_contact_name"
                  label="Reimbursement contact name"
                >
                  <Input placeholder="First and last name of the financial reimbursement contact at this address" />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="dispensing_pharmacy_contact_phone"
                  label="Reimbursement contact phone"
                >
                  <Input.OTP length={10} />
                </Form.Item>
              </Col>
            </Row>
          ),
        },
      ]}
    />
  );
};

export default ReimbursementAddress;
